<app-header-translator 
  [title]="'COMPARE_SEND.HEADLINE' | translate"
  [textContent]="'COMPARE_SEND.INSTRUCTIONS.TEXT' | translate"
  [anchorHref]="(eqaUrl | lowercase) + ('GLOBAL.PARTICIPATING_INSURER_URL' | translate | lowercase)"
  [anchorText]="'COMPARE_SEND.INSTRUCTIONS.LINK' | translate"
  (languageSelected)="useLanguage()">
</app-header-translator>

<ng-container *ngIf="!showTableView()">
  <div class="container-standout mb-4" *ngFor="let q of quotes; let i = index">
    <div class="d-flex justify-content-center mb-2">
      <span class="text-primary fw-bold">
        {{'COMPARE_SEND.TAP_NUMBER' | translate }}
      </span>    
    </div>
    <div class="container-standout-estimate px-4 py-2">
      <div class="row mb-3">
        <button 
          class="btn btn-light btn-lg btn-block border"
          (click)="selectCalculation(i, $event)"
          [ngClass]="{'active' : ids.indexOf(i) > -1}">
            {{ i + 1 }}
        </button>
      </div>
      <div class="row">
        <div class="col-6">
          <div class="mb-2">
            {{'COMPARE_SEND.COMPARE_TABLE.MONTHLY_HEADER' | translate }}
          </div>
        </div>
        <div class="col-6">
          <div class="mb-2 text-primary text-end fw-bold">
            ${{q.MonthlyPremium | number:'1.2-2'  }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <div class="mb-2">
            {{'COMPARE_SEND.COMPARE_TABLE.ANNUALLY_HEADER' | translate }}
          </div>
        </div>
        <div class="col-6">
          <div class="mb-2 text-primary text-end fw-bold">
            ${{q.AnnualPremium  | number:'1.2-2'}}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <div class="mb-2">
            {{'COMPARE_SEND.COMPARE_TABLE.POLICY_TYPE_HEADER' | translate }}
          </div>
        </div>
        <div class="col-6">
          <div class="mb-2 text-primary text-end fw-bold">
            {{q.PolicyTypeTranslate}}
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-center gap-3">
        <button 
          class="btn btn-light btn-sm border fw-bold btn-estimate-action"          
          (click)="editCalculation(i, $event)">
          {{'COMPARE_SEND.COMPARE_TABLE.EDIT_BUTTON' | translate }}
        </button>
        <button 
          class="btn btn-light btn-sm border fw-bold btn-estimate-action"
          (click)="removeCalculation(i, content, $event)">
          {{'COMPARE_SEND.COMPARE_TABLE.REMOVE_BUTTON' | translate }}
        </button>
      </div>
    </div>
  </div>
  <ng-template #content let-modal>
    <div class="modal-header">
      <h5>{{'COMPARE_SEND.CONFIRM_ESTIMATE_DELETE_TITLE' | translate}}</h5>
    </div>
    <div class="modal-body">
      <p>{{'COMPARE_SEND.CONFIRM_ESTIMATE_DELETE' | translate}}</p>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-blue"
              (click)="yesRemovePolicy(modal)">
        {{'GLOBAL.YES' | translate}}
      </button>
      <button type="button" class="btn btn-blue"
              (click)="modal.close()">
        {{'GLOBAL.NO' | translate}}
      </button>
    </div>
  </ng-template>
</ng-container>

<ng-container *ngIf="showTableView()">
  <div class="standout-container-table">
    <table id="tbl-estimates" class="table table-bordered table-sm w-100">
      <caption class="sr-only">
      {{'COMPARE_SEND.INSTRUCTIONS.TEXT' | translate}} {{'COMPARE_SEND.INSTRUCTIONS.LINK' | translate}}
      </caption>
      <thead>
        <tr>
          <th class="text-uppercase">{{'COMPARE_SEND.COMPARE_TABLE.SELECT_HEADER' | translate }}</th>
          <th class="text-uppercase">{{'COMPARE_SEND.COMPARE_TABLE.MONTHLY_HEADER' | translate }}</th>
          <th class="text-uppercase">{{'COMPARE_SEND.COMPARE_TABLE.ANNUALLY_HEADER' | translate }}</th>
          <th class="text-uppercase">{{'COMPARE_SEND.COMPARE_TABLE.POLICY_TYPE_HEADER' | translate }}</th>
          <td></td> <!-- empty td for accessibility reasons -->
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let q of quotes; let i = index">
          <td 
            [ngClass]="{'active' : ids.indexOf(i) > -1}"
            (click)="selectCalculation(i, null)">
            {{i + 1}}
          </td>
          <td>
            ${{q.MonthlyPremium  | number:'1.2-2' }}
          </td>
          <td>
            ${{q.AnnualPremium | number:'1.2-2'}}
          </td>
          <td class="text-uppercase">
            {{q.PolicyTypeTranslate}}
          </td>
          <td>
            <div class="d-flex justify-content-center gap-2">
              <button class="btn btn-light btn-sm border fw-bold btn-estimate-action"
                  (click)="editCalculation(i, $event)">
                {{'COMPARE_SEND.COMPARE_TABLE.EDIT_BUTTON' | translate }}
              </button>
              <button class="btn btn-light btn-sm border fw-bold btn-estimate-action"
                style="margin-left: 3px !important;"
                (click)="removeCalculation(i, content, $event)">
                {{'COMPARE_SEND.COMPARE_TABLE.REMOVE_BUTTON' | translate }}
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="table-footer d-flex justify-content-center">
      <button class="btn btn-danger w-100 mb-4 btn-sm mx-0"
          id="btn-start-over"
          (click)="clearAndStartOver(false)">
          {{'COMPARE_SEND.COMPARE_TABLE.START_OVER_BUTTON' | translate }}
      </button>
      <button *ngIf="this.quotes.length !== 10" class="btn btn-add w-100 mb-4 btn-sm mx-0" 
          (click)="addNewCompare()">
          {{'COMPARE_SEND.COMPARE_TABLE.NEW_ESTIMATE_BUTTON' | translate }}
          <i class="fas fa-plus" aria-hidden="true"></i>
      </button>
      <div *ngIf="this.quotes.length === 10" class="bg-light w-100 mb-4 text-center align-middle">
          <span>
              {{'COMPARE_SEND.COMPARE_TABLE.MAX_LIMIT' | translate }}
          </span>
      </div>
    </div>
  </div>
  <ng-template #content let-modal>
    <div class="modal-header">
      <h3>{{'COMPARE_SEND.CONFIRM_ESTIMATE_DELETE_TITLE' | translate}}</h3>
    </div>
    <div class="modal-body">
      <p>{{'COMPARE_SEND.CONFIRM_ESTIMATE_DELETE' | translate}}</p>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary"
              (click)="yesRemovePolicy(modal)">
        {{'GLOBAL.YES' | translate}}
      </button>
      <button type="button" class="btn btn-accent"
              (click)="modal.close()">
        {{'GLOBAL.NO' | translate}}
      </button>
    </div>
  </ng-template>
  <div class="row">
    <div class="col-6">
      <div class="container-standout p-4 bg-primary">
        <h3 class="text-white text-center mb-3">{{'COMPARE_SEND.SUPPORT_INSURER.TITLE' | translate }}</h3>
        <p class="text-white text-center fs-7 px-3" [innerHTML]='supportInsurerTxt'></p>
        <div *ngIf="showRelatedPi()" class="mt-4">
          <a              
            class="btn btn-light w-100 fw-bold"
            href="{{findAgentUrl | lowercase}}"
            target="_blank"
            rel="noopener">{{'COMPARE_SEND.FIND_AGENT_BUTTON' | translate }}
          </a>
        </div>
      </div>    
    </div>
    <div class="col-6">
      <div class="container-standout p-4">
        <h3 class="text-primary text-center mb-3"  style="font-weight: bold !important">{{'COMPARE_SEND.TECHNICAL_SUPPORT.TITLE' | translate }}</h3>
        <p class="text-primary text-center fs-7 px-3">
          {{'COMPARE_SEND.TECHNICAL_SUPPORT.TEXT1' | translate }}
          <a class="text-primary" href="{{eqaUrl | lowercase}}{{'GLOBAL.BROWSER_SUPPORT_URL' | translate | lowercase}}" target="_parent">
              {{'COMPARE_SEND.TECHNICAL_SUPPORT.BROWSER_COMPATIBLE' | translate }}
          </a>
          {{'COMPARE_SEND.TECHNICAL_SUPPORT.TEXT2' | translate }}
        </p>
        <div class="mt-4">
          <a 
            target="_parent"
            href="{{eqaUrl | lowercase}}{{'GLOBAL.CONTACT_URL' | translate | lowercase}}" 
            class="btn btn-primary w-100 fw-bold">
            {{'COMPARE_SEND.EMAIL_SUPPORT' | translate }}
          </a>
        </div>
      </div>
    </div>
  </div>  
</ng-container>

<div *ngIf="!showTableView()" class="container-standout mt-4 p-4">
    <div class="row">
          <div *ngIf="this.quotes.length !== 10" class="col-12 col-md-6" >
              <button class="btn btn-tertiary w-100 mb-4" 
                (click)="addNewCompare()">
                {{'COMPARE_SEND.COMPARE_TABLE.NEW_ESTIMATE_BUTTON' | translate }}
                <i class="fas fa-plus" aria-hidden="true"></i>
              </button>                          
          </div>
          <div *ngIf="this.quotes.length === 10" class="col-12 col-md-6">
              <div class="w-100 mb-4 text-center">
                <span>
                  {{'COMPARE_SEND.COMPARE_TABLE.MAX_LIMIT' | translate }}
                </span>
              </div>
          </div>
          <div class="col-12 col-md-6">
              <button class="btn btn-danger w-100 mb-4"
                    id="btn-start-over"
                    (click)="clearAndStartOver(false)">
                    {{'COMPARE_SEND.COMPARE_TABLE.START_OVER_BUTTON' | translate }}
              </button>
          </div>
    </div>
    <div class="row">
          <div class="col-12 col-md-6">
              <!-- <button class="btn btn-tertiary w-100 mb-4"
                    id="btn-download"
                    (click)="download($event)"
                    [disabled]="processing || showError">
                    {{'COMPARE_SEND.PRINT_DOWNLOAD_BUTTON' | translate }}
              </button> -->
              <a *ngIf="showRelatedPi()" class="btn btn-tertiary w-100 mb-4" 
                href="{{findAgentUrl | lowercase}}"
                target="_blank" 
                rel="noopener">
                {{'COMPARE_SEND.FIND_AGENT_BUTTON' | translate }}
              </a>
          </div>
          <div class="col-12 col-md-6">
              <!-- <button class="btn btn-tertiary w-100 mb-4"
                    id="btn-compare"
                    (click)="compare($event)"
                    [disabled]="processing || showError">
                    {{'COMPARE_SEND.COMPARE_BUTTON' | translate}}
              </button> -->
              <a class="btn btn-tertiary w-100 mb-3"
                href="{{eqaUrl | lowercase}}{{'GLOBAL.CONTACT_URL' | translate | lowercase}}"
                target="_parent">
                {{'COMPARE_SEND.EMAIL_SUPPORT' | translate }}
              </a>
          </div>
    </div>                   
</div>

<div class="mt-4">
  <h2>
    <span *ngIf="policy === 1">
      {{'COMPARE_SEND.HOMEOWNERS_ESTIMATE' | translate }}
    </span>
    <span *ngIf="policy === 2">
      {{'COMPARE_SEND.RENTERS_ESTIMATE' | translate }}
    </span>
    <span *ngIf="policy === 3">
      {{'COMPARE_SEND.CONDO_OWNERS_ESTIMATES' | translate }}
    </span>
    <span *ngIf="policy === 4">
      {{'COMPARE_SEND.MOBILEHOME_OWNERS_ESTIMATES' | translate }}
    </span>
  </h2>
  <p>
    <span *ngIf="policy === 1">
      {{'COMPARE_SEND.MINIMUM_HOMEOWNER' | translate }}
    </span>
    <span *ngIf="policy === 2">
      {{'COMPARE_SEND.MINIMUM_RENTER' | translate }}
    </span>
    <span *ngIf="policy === 3">
      {{'COMPARE_SEND.MINIMUM_CONDO' | translate }}
    </span>
    <span *ngIf="policy === 4">
      {{'COMPARE_SEND.MINIMUM_MOBILE' | translate }}
    </span>
  </p>
</div>

<div class="mt-4 mb-4">
  <span class="d-flex text-primary fw-bold gap-2">
    <i class="fas fa-map-marker-alt text-danger pt-1" aria-hidden="true"></i>
    {{getCompleteAddress()}}
  </span>
</div>

<div *ngIf="showCompare()">
  <p class="mb-0">
    {{getYesComparePolicyNameById()}}<br>
    {{getOppositePolicyNameById()}}    
  </p>
  <div class="d-flex justify-content-between mb-4">
    <a class="link-color" href="javascript:void()" (click)="policyDiffPop()">
      {{'COMPARE_SEND.WHATS_DIFFERENCE_HOME_HELP.DIFFERENCE_TEXT' | translate}}
    </a>
    <button 
      (click)="yesCompare(getPolicyNameByIdYesCompare(policy))"
      class="btn btn-primary btn-sm">
      {{'GLOBAL.YES' | translate}}
    </button>
  </div>
</div>

<table id="tbl-estimates-details" class="table table-sm">
  <ng-container *ngFor="let row of table;let rowIndex=index;">
    <tr *ngIf="row.key !== 'foundationType' && row.key !== 'frame' && row.key !== 'roofTypeVariable' && row.key !== 'stories'">
      <td [ngClass]="{'text-primary fw-bold' : row.class === 'first'}">{{row.label}}</td>
      <td class="text-end text-primary fw-bold" [ngClass]="{'first' : row.valueClass === 'first'}">
        <span *ngIf="page===1">{{row["value0"]}}</span>
        <span *ngIf="(page==2 && perPage===4) || (page==3 && perPage===2) || (page==5 && perPage===1)">{{row["value4"]}}</span>
        <span *ngIf="(page==3 && perPage===4) || (page==5 && perPage===2) || (page==9 && perPage===1)">{{row["value8"]}}</span>
        <span *ngIf="(page==2 && perPage===3) || (page==4 && perPage===1)">{{row["value3"]}}</span>
        <span *ngIf="(page==3 && perPage===3) || (page==4 && perPage===2) || (page==7 && perPage===1)">{{row["value6"]}}</span>
        <span *ngIf="(page==4 && perPage===3) || (page==10 && perPage===1)">{{row["value9"]}}</span>
        <span *ngIf="(page==2 && perPage===2) || (page==3 && perPage===1)">{{row["value2"]}}</span>
        <span *ngIf="page==2 && perPage===1">{{row["value1"]}}</span>
        <span *ngIf="page==6 && perPage===1">{{row["value5"]}}</span>
        <span *ngIf="page==8 && perPage===1">{{row["value7"]}}</span>
      </td>
      <td class="text-end text-primary fw-bold"
          *ngIf="(((ids.length >
        1 && page==1) || (ids.length > 5 && page==2) || (ids.length > 9 && page==3)) && perPage===4)
        || (((ids.length > 1 && page==1) || (ids.length > 4 && page==2) || (ids.length > 7 && page==3)) && perPage===3)
        || (((ids.length > 1 && page==1) || (ids.length > 3 && page==2) || (ids.length > 5 && page==3) || (ids.length > 7 && page==4) || (ids.length > 9 && page==5)) && perPage===2)"
        [ngClass]="{'first' : row.valueClass === 'first'}" style="width:150px">
        <span *ngIf="page==1">{{row["value1"]}}</span>
        <span *ngIf="(page==2 && perPage===4) || (page==3 && perPage===2)">{{row["value5"]}}</span>
        <span *ngIf="(page==3 && perPage===4) || (page==5 && perPage===2)">{{row["value9"]}}</span>
        <span *ngIf="page==2 && perPage===3">{{row["value4"]}}</span>
        <span *ngIf="(page==3 && perPage===3) || (page==4 && perPage===2)">{{row["value7"]}}</span>
        <span *ngIf="page==2 && perPage===2">{{row["value3"]}}</span>
      </td>
      <td class="text-end text-primary fw-bold"
          *ngIf="(((ids.length >
          2 && page==1) || (ids.length > 6 && page==2) || (ids.length > 9 && page==3)) && perPage===4)
          || (((ids.length > 2 && page==1) || (ids.length > 6 && page==2) || (ids.length > 8 && page==3)) && perPage===3)"
          [ngClass]="{'first' : row.valueClass === 'first'}" style="width:150px">
          <span *ngIf="page==1">{{row["value2"]}}</span>
          <span *ngIf="page==2 && perPage===4">{{row["value6"]}}</span>
          <span *ngIf="page==2 && perPage===3">{{row["value5"]}}</span>
          <span *ngIf="page==3 && perPage===3">{{row["value8"]}}</span>
      </td>
      <td class="text-end text-primary fw-bold"
          *ngIf="((ids.length > 3 && page==1) || (ids.length > 7 && page==2)) && perPage===4"
          [ngClass]="{'first' : row.valueClass === 'first'}" style="width:150px">
        <span *ngIf="page==1">{{row["value3"]}}</span>
        <span *ngIf="page==2">{{row["value7"]}}</span>
      </td>
    </tr>
  </ng-container>
</table>

<div id="tbl-estimates-paging-controls" class="d-flex justify-content-center gap-3">
  <button class="btn btn-sm btn-link text-primary mx-0 px-0"
    (click)="setPage(1)"
    [disabled]="page === 1">
    <i class="fas fa-backward" aria-hidden="true"></i>
    <span class="sr-only">
      {{'COMPARE_SEND.FIRST_PAGE' | translate}}
    </span>
  </button>
  <button class="btn btn-sm btn-link text-primary mx-0 px-0"
    (click)="setPage(page - 1)"
    [disabled]="page === 1">
    <i class="fas fa-caret-left" aria-hidden="true"></i>
    <span class="sr-only">
      {{'COMPARE_SEND.PREVIOUS_PAGE' | translate}}
    </span>
  </button>  
  <span class="mt-2">
    {{page}} {{'COMPARE_SEND.OF' | translate}} {{pages}}
  </span>
  <button class="btn btn-sm btn-link text-primary mx-0 px-0"
    (click)="setPage(page + 1)"
    [disabled]="page >= pages">
    <i class="fas fa-caret-right" aria-hidden="true"></i>
    <span class="sr-only">
      {{'COMPARE_SEND.NEXT_PAGE' | translate}}
    </span>
  </button>
  <button class="btn btn-sm btn-link text-primary mx-0 px-0"
    (click)="setPage(pages)"
    [disabled]="page >= pages">
    <i class="fas fa-forward" aria-hidden="true"></i>
    <span class="sr-only">
      {{'COMPARE_SEND.LAST_PAGE' | translate}}
    </span>
  </button>  
</div>

<div id="report-footer-text" *ngIf="showTable">
  <div class="details-text ng-binding ng-hide" style="display: inline-block;"
        ng-show="calculatorSettings.compareAndSendPageSettings.customCallToActionHtml"
        ng-bind-html="trustAsHtml(calculatorSettings.compareAndSendPageSettings.customCallToActionHtml)">
  </div>

  <div class="details-text ng-binding" style="display: inline-block; text-align: justify">
    {{"COMPARE_SEND.TERMS_TEXT" | translate }}
  </div>
</div>

<div class="actions container-standout mb-4 mt-4 px-4 py-4">
  <div class="row">
      <div class="col-12 col-md-6">
          <button 
            class="btn btn-tertiary w-100 mb-3" 
            id="compare-back-btn" 
            [disabled]="!showTable" 
            (click)="goBack()">
            <i class="fas fa-arrow-left" aria-hidden="true"></i>
            {{'GLOBAL.BACK_BUTTON' | translate }}
          </button>
      </div>
      <div class="col-12 col-md-6">
          <button 
            [disabled]="!showTable" 
            class="btn btn-tertiary w-100 mb-3" 
            (click)="download($event)" 
            id="compare-download-btn">
            <i class="fas fa-print" aria-hidden="true"></i>
            {{'COMPARE_SEND.DOWNLOAD_BUTTON' | translate }}
          </button>
      </div>
  </div>
</div>
